"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const navigationHelpers_1 = require("evolution-common/lib/services/questionnaire/sections/navigationHelpers");
const widgetsNames_1 = require("./widgetsNames");
const customPreload_1 = require("./customPreload");
const helper_1 = require("../../common/helper");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
exports.currentSectionName = 'household';
const previousSectionName = 'home';
const nextSectionName = 'personsTrips';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Ménage',
        en: 'Household'
    },
    navMenu: {
        type: 'inNav',
        menuName: {
            fr: 'Ménage',
            en: 'Household'
        }
    },
    widgets: widgetsNames_1.widgetsNames,
    // Do some actions before the section is loaded
    preload: customPreload_1.customPreload,
    // Allow to click on the section menu
    enableConditional: function (interview) {
        return (0, navigationHelpers_1.isSectionCompleted)({ interview, sectionName: previousSectionName });
    },
    // Allow to click on the section menu
    completionConditional: function (interview) {
        return (0, helper_1.householdMembersSectionComplete)(interview);
    },
    onSectionExit: (interview, iterationContext) => {
        const personsCount = odSurveyHelper.countPersons({ interview });
        const householdSize = (0, helpers_1.getResponse)(interview, 'household.size', null);
        // Make the household size match the number of household members in this section
        if (householdSize !== personsCount) {
            return {
                ['response.household.size']: personsCount
            };
        }
        return undefined;
    }
};
exports.default = exports.sectionConfig;
